const PRESENTER_USER_AGENT_REGEX = /(PollEvPresenter|LiveSlides)\/(\d+\.\d+\.\d+)/
const ELECTRON_USER_AGENT_REGEX = /(@polleverywhere\/electron-app)\/(\d+\.\d+\.\d+)/

export function appInfo () {
  // windows | mac | ios | android
  const operatingSystem = getOS()

  const appVersion = getAppVersion()

  // electron | google | liveslides | presenter
  const platform = getPlatform()

  const ret = {
    appVersion,
    operatingSystem,
    platform
  }

  if (operatingSystem.length) {
    ret[operatingSystem] = true
  }

  if (platform.length) {
    ret[platform] = true
  }

  return ret
}

const info = appInfo()
export default info

function getPlatform () {
  if (navigator.userAgent.match(/pollevpresenter/i)) {
    return 'presenter'
  } else if (navigator.userAgent.match(/liveslides/i)) {
    return 'liveslides'
  } else if (navigator.userAgent.match(/electron/i)) {
    return 'electron'
  } else if (window.parent !== window) {
    // We don't have control over the userAgent in goog_presenter
    // but we can check if we're running in an <iframe>
    return 'google'
  }

  return ''
}

function getOS () {
  if (navigator.userAgent.match(/Windows/)) {
    return 'windows'
  }

  if (navigator.userAgent.match(/Mac OS X/) && !navigator.userAgent.match(/like Mac OS X/)) {
    return 'mac'
  }

  if (navigator.userAgent.match(/iPad|iPhone|iPod/)) {
    return 'ios'
  }

  if (navigator.userAgent.match(/Android/)) {
    return 'android'
  }
  return ''
}

function getAppVersion () {
  for (const regex of [PRESENTER_USER_AGENT_REGEX, ELECTRON_USER_AGENT_REGEX]) {
    const matches = regex.exec(navigator.userAgent)
    if (matches) {
      return matches[2]
    }
  }

  return ''
}
